const PHRASES = [
  "Look deeper",
  "Prioritise better",
  "Personalise intelligently",
  "Precision",
  "Calm",
  "Evidence-informed",
  "Physician-led",
];

export const Marquee = () => {
  const row = [...PHRASES, ...PHRASES];
  return (
    <div className="relative overflow-hidden border-y border-line bg-paper py-5" aria-hidden="true" data-testid="editorial-marquee">
      <div className="flex whitespace-nowrap animate-marquee-slow w-max">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center">
            {row.map((p, i) => (
              <span key={`${half}-${i}`} className="flex items-center">
                <span className="font-serif italic text-xl sm:text-2xl text-forest/80 px-8">{p}</span>
                <span className="h-1.5 w-1.5 rotate-45 bg-gold/70" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
